import { getCurrentWorkspace } from "@/lib/workspaceBranding";

const PRODUCT_APP_TITLES = new Set([
  "SIGMA",
  "Sigma by Latino Business Support",
  "Nomi CRM",
  "LBS CRM",
  "Atomic CRM",
  "LBS",
  "Nomi",
  "NOMI",
  "NOMI CRM",
]);

export const INVOICE_ORGANIZATION_NAME = "Latino Business Support";

export const INVOICE_ORGANIZATION_ADDRESS_LINE =
  "1200 Summer St, Stamford CT, 06902";

export const INVOICE_ORGANIZATION_PHONE = "(203) 303-9148";

export const INVOICE_ORGANIZATION_EMAIL = "info@lbs.bz";

export const INVOICE_ORGANIZATION_WEBSITE = "www.lbs.bz";

export const INVOICE_ORGANIZATION_CONTACT_LINE = `${INVOICE_ORGANIZATION_PHONE} | ${INVOICE_ORGANIZATION_EMAIL}`;

/** Street + phone/email — name and website are shown separately on the document. */
export const INVOICE_ORGANIZATION_ADDRESS_BLOCK = `${INVOICE_ORGANIZATION_ADDRESS_LINE}\n${INVOICE_ORGANIZATION_CONTACT_LINE}`;

export type InvoiceOrganizationBranding = {
  name: string;
  address: string;
  website: string;
  phone: string;
  email: string;
};

/** LBS (home org) keeps its details; other companies show their own. */
export const getInvoiceOrganizationBranding =
  (): InvoiceOrganizationBranding => {
    const workspace = getCurrentWorkspace();
    if (workspace.isHome) {
      return {
        name: INVOICE_ORGANIZATION_NAME,
        address: INVOICE_ORGANIZATION_ADDRESS_BLOCK,
        website: INVOICE_ORGANIZATION_WEBSITE,
        phone: INVOICE_ORGANIZATION_PHONE,
        email: INVOICE_ORGANIZATION_EMAIL,
      };
    }
    const contact = [workspace.phone, workspace.email]
      .filter(Boolean)
      .join(" | ");
    return {
      name: workspace.name,
      address: [workspace.address, contact].filter(Boolean).join("\n"),
      website: workspace.website,
      phone: workspace.phone,
      email: workspace.email,
    };
  };

/** Public-facing org name for invoice emails and PDFs — not the app product title. */
export const resolveInvoiceOrganizationName = (config?: {
  title?: string | null;
  companyLegalName?: string | null;
}) => {
  const legal = config?.companyLegalName?.trim();
  if (legal && !PRODUCT_APP_TITLES.has(legal)) return legal;

  const title = config?.title?.trim();
  if (title && !PRODUCT_APP_TITLES.has(title)) return title;

  const workspace = getCurrentWorkspace();
  return workspace.isHome
    ? INVOICE_ORGANIZATION_NAME
    : workspace.name || INVOICE_ORGANIZATION_NAME;
};

export const buildInvoiceOrganizationEmailTagline = () => {
  const workspace = getCurrentWorkspace();
  if (workspace.isHome) {
    return `${INVOICE_ORGANIZATION_ADDRESS_LINE} · ${INVOICE_ORGANIZATION_CONTACT_LINE} · ${INVOICE_ORGANIZATION_WEBSITE}`;
  }
  return [
    workspace.address,
    workspace.phone,
    workspace.email,
    workspace.website,
  ]
    .filter(Boolean)
    .join(" · ");
};
